
export function BedsFilter({ value, onChange }) {

    const handleChange = (e) => {
      let beds = e.target.value;
      onChange(beds);
    };

    return(
      <div className="filter">
        <div className="filter-button">
          <input type="radio" name="beds" defaultChecked={value==0} value="0" onChange={handleChange} id="studio" />
          <label htmlFor="studio">Studio</label>
        </div>
        <div className="filter-button">
          <input type="radio" name="beds" defaultChecked={value==1} value="1" onChange={handleChange} id="1bed" />
          <label htmlFor="1bed">1</label>
        </div>
        <div className="filter-button">
          <input type="radio" name="beds" defaultChecked={value==2} value="2" onChange={handleChange} id="2bed" />
          <label htmlFor="2bed">2</label>
        </div>
        <div className="filter-button">
          <input type="radio" name="beds" defaultChecked={value==3} value="3" onChange={handleChange} id="3bed" />
          <label htmlFor="3bed">3+</label>
        </div>
      </div>
    );
}